/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // 加购面板尺码表相关
  function initQuickAddCustom() {
    const initTransformIn2ch = (parent) => {
      // 厘米转化英寸
      const cmToInches = (cm) => {
        const cmPerInch = 2.54
        // const inchesPerFoot = 12
        
        const inches = cm / cmPerInch
        // const feet = inches / inchesPerFoot
        
        return inches.toFixed(2)
      }
      
      // 厘米表格转化为英尺表格
      const transformToIn = (table) => {
        const inTable = table.cloneNode(true)
        let items = inTable.querySelectorAll('p')
        if(items.length <= 0) {
          items = inTable.querySelectorAll('td')
        }
        const regex = /^(?=.*\d)(?!.*X).*$/
        const numRegex = /^\d+$/
        items.forEach(item => {
          if(item.querySelector('span')) {
            item = item.querySelector('span')
            if(item.querySelector('span')) {
              item = item.querySelector('span')
            }
          }
          // 单元格内有数字，且没有X（排除2XL）、单元格不是纯数字（带cm单位）
          if(regex.test(item.innerHTML) && !numRegex.test(item.innerHTML) && item.innerHTML.includes('cm')) {
            // 覆盖类似 53-70cm的情况
            const cmArr = item.innerHTML.split('-')
            if(cmArr.length > 1) {
              item.innerHTML = `${cmToInches(parseInt(cmArr[0]))}-${cmToInches(parseInt(cmArr[1]))}in`
            } else {
              item.innerHTML = `${cmToInches(parseInt(item.innerHTML))}in`
            }
          }
        })
        return inTable
      }
      
      parent.querySelectorAll('.rte__table-wrapper').forEach(tableWrapper => {

        if(!tableWrapper) {
          return
        }
        const wrapperTableHTML = tableWrapper.querySelector('table').innerHTML
        if(!wrapperTableHTML.includes("cm") || wrapperTableHTML.includes("Fabric type")) {
          return
        }
        if(tableWrapper.querySelector('.size-transformer')) {
          return
        }
    
        // 初始化厘米表格内容和英尺表格内容
        const table = tableWrapper.querySelector('table')
        let cmContent = tableWrapper.querySelector('table').cloneNode(true)
        const inContent = transformToIn(cmContent)
    
        // 插入按钮
        const transformButton = document.createElement('div')
        transformButton.innerHTML = `
          <div class="size-transform-cm" active>CM</div>
          <div class="size-transform-in">IN</div>
        `
        transformButton.className = 'size-transformer'
        table.parentNode.insertBefore(transformButton, table.parentNode.firstChild)
    
        // 绑定点击事件，切换表格
        const cmButton = transformButton.querySelector('.size-transform-cm')
        const inButton = transformButton.querySelector('.size-transform-in')
        cmButton.addEventListener('click', () => {
          inButton.removeAttribute('active')
          cmButton.setAttribute('active', 'true')
          table.innerHTML = cmContent.innerHTML
          // table.appendChild(cmContent)
          // table.replaceChild(cmContent, table.firstChild)
        })
        inButton.addEventListener('click', () => {
          inButton.setAttribute('active', 'true')
          cmButton.removeAttribute('active')
          table.innerHTML = inContent.innerHTML
          // table.appendChild(inContent)
          // table.replaceChild(inContent, table.firstChild)
        })
      })
    }
    const initSizeDrump = (parent) => {
      // 点击sizechart按钮，滚动到尺码表
      parent.querySelector('.size-drump')?.addEventListener('click', (e) => {
          e.preventDefault()
          parent.querySelector('.product-quick-add__description-mask')?.click()
          setTimeout(() => {
            parent.querySelectorAll('.rte__table-wrapper')[1]?.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }, 225)
      })
    }

    const observer = new MutationObserver((mutationsList, obs) => {
      const viewButtons = document.querySelectorAll(".product-quick-add__description-mask");
      
      if (viewButtons.length > 0) {
        viewButtons.forEach(button => {
          const parent = button.closest(".product-quick-add__description")
          button.onclick = () => {
            const content = parent.querySelector(".product-quick-add__description-content")
            content.style.maxHeight = "unset"
            button.style.display = "none"
          }

          initTransformIn2ch(parent)
          initSizeDrump(button.closest(".product-quick-add__form"))
        })
      }
    });

    const observerConfig = {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false
    };

    const observeTarget = document.body;
    observer.observe(observeTarget, observerConfig);
  }

  initQuickAddCustom()



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
